import { EXACT_ONLY_KINDS } from '../components/SearchChipBar';
import type { ChipKind } from '../types';

/** Native sources retain their source-specific routing and validation. */
export const NATIVE_SOURCES: ReadonlySet<string> = new Set(['jp_ja', 'de', 'fr', 'ch_src', 'it']);

type RowLike = { keyword: string; drug_field?: string | null | undefined; match_type?: string };

const isPattern = (r: RowLike) =>
  !!r.drug_field && !EXACT_ONLY_KINDS.has(r.drug_field as ChipKind) && /\*|\+$/.test(r.keyword);

/** ``pfiz+`` -> ``pfiz*``; a bare pattern value ``pfi`` -> ``*pfi*``. */
export function patternKeyword(value: string): string {
  const v = value.replace(/\+$/, '*');
  return v.includes('*') ? v : `*${v}*`;
}

export function canonicalRow<R extends RowLike>(r: R): R {
  return isPattern(r)
    ? { ...r, keyword: r.keyword.replace(/\+$/, '*'), match_type: 'exact' }
    : { ...r, match_type: 'exact' };
}

/** Apply the rule to every row of a keyword request (``groups`` or legacy flat
 *  ``rows``). Used during restore and at the API boundary so every sender is consistent. */
export function coerceKeywordRequest<T extends Record<string, unknown>>(req: T): T {
  const mapRows = (rows: unknown) => (Array.isArray(rows) ? rows.map((r) => canonicalRow(r as RowLike)) : rows);
  const groups = req['groups'];
  return {
    ...req,
    ...(Array.isArray(groups)
      ? { groups: groups.map((g: { rows?: unknown }) => ({ ...g, rows: mapRows(g.rows) })) }
      : {}),
    ...(Array.isArray(req['rows']) ? { rows: mapRows(req['rows']) } : {}),
  };
}
